import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import * as React from 'react';
import { ICase } from '../../../../../../../../../types/case';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import DataSheetLabel from '../../../../../../../../../components/common/DatasheetLabel';
import classNames from 'classnames';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faListAlt, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';

interface Params {
    id: string;
    caseCurrent: ICase | null;
    statusEnum: any;
    canInvoice: boolean;
    setManualAction: (val: any) => void;
    manualAction: any;
}

const getRowsSessionManual = (
    data: any,
    { id, caseCurrent, statusEnum, canInvoice, setManualAction, manualAction }: Params,
) => {
    const dataSessionComponents: any = [];
    data.forEach((itSes: any) => {
        if (caseCurrent?.caseType !== 2 && itSes.status !== 4 && itSes.status !== 5) {
            canInvoice = false;
        }
        const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
        const statusItems: SelectObject[] = getValFromEnum(statusEnum);
        let valueCaseStatus = '';
        const canConfirm = true;
        statusItems.forEach((it, l, arr) => {
            if (+it.value === 5) {
            }
            if (+it.value === +itSes.status) {
                valueCaseStatus = it.label;
            }
        });
        if (!canConfirm) {
            statusItems.forEach((it, l, arr) => {
                if (it.value === 4) {
                    statusItems.splice(l, 1);
                }
            });
        }
        let serviceType = itSes?.serviceType?.title;
        if (!serviceType) {
            serviceType = itSes?.serviceType?.cpt;
        }
        const locationArr: string[] = [];
        locationArr.push(itSes['serviceLocation'] ? itSes['serviceLocation']?.title : '');
        if (itSes.isHome) {
            locationArr.push('[Home]');
        }
        if (itSes.isInPerson) {
            locationArr.push('[In Person]');
        }
        if (itSes.isTelehealth) {
            locationArr.push('[Telehealth]');
        }
        if (itSes.isSchool) {
            locationArr.push('[School - Telehealth]');
        }

        const locationTitle = locationArr.join(', ');
        const handleChange = (d: any) => {
            manualAction[+itSes['id']] = !manualAction[+itSes['id']];

            setManualAction(manualAction);
        };
        const dataSheet: string = itSes.datasheet.join(',');
        dataSessionComponents.push({
            ...itSes,
            totalUnit: itSes.totalUnit,
            externalRatePerHour: itSes.externalRatePerHour
                ? `$${numberWithCommas(itSes.externalRatePerHour)}`
                : '$0.00',
            externalRatePerUnit: itSes.externalRatePerUnit
                ? `$${numberWithCommas(itSes.externalRatePerUnit)}`
                : '$0.00',
            internalRatePerHour: itSes.internalRatePerHour
                ? `$${numberWithCommas(itSes.internalRatePerHour)}`
                : '$0.00',
            internalRatePerUnit: itSes.internalRatePerUnit
                ? `$${numberWithCommas(itSes.internalRatePerUnit)}`
                : '$0.00',
            totalFee: itSes.totalFee ? `$${numberWithCommas(itSes.totalFee)}` : '$0.00',
            action: (
                <div style={{ display: 'block', padding: 15, background: 'rgba(62, 129, 185, 0.3)', margin: '-5px' }}>
                    <input
                        type="checkbox"
                        checked={manualAction[+itSes['id']]}
                        onClick={(value) => handleChange(value)}
                    />
                </div>
            ),
            signDoc: itSes['signDoc'] ? (
                <a rel="noopener noreferrer" target="_blank" href={`${itSes['signDoc']}`}>
                    Note
                </a>
            ) : (
                ''
            ),
            id: itSes['id'],
            datasheet: <DataSheetLabel text={dataSheet} />,
            isConfirmed: +itSes.status === 4 ? true : false,
            status: valueCaseStatus,

            serviceLocation: <div>{locationTitle}</div>,
            serviceType: <div>{serviceType}</div>,
            seanceDate: itSes.seanceDate ? (
                <div className={classNames(styles.date)}>
                    {changeToZeroMoment(itSes['seanceDate'], 'MMM D, YYYY')}
                    {itSes.isWeekly ? (
                        <FontAwesomeIcon
                            style={{
                                position: 'absolute',
                                bottom: '5px',
                                top: 'auto',
                                fontSize: '10px',
                                right: '3%',
                            }}
                            icon={faSyncAlt}
                        />
                    ) : null}
                    {isAdmin && itSes.hasPaid ? (
                        <div className={classNames(styles.dollarIcon)}>
                            <FontAwesomeIcon icon={faDollarSign} />
                        </div>
                    ) : isAdmin && itSes.hasInvoiced ? (
                        <div className={classNames(styles.dollarIcon, styles.invoicedIcon)}>
                            <FontAwesomeIcon icon={faListAlt} />
                        </div>
                    ) : null}
                </div>
            ) : (
                ''
            ),
            startTime: itSes.startTime ? changeToZeroMoment(itSes['startTime'], 'LT') : '',
            endTime: itSes.endTime ? changeToZeroMoment(itSes['endTime'], 'LT') : '',
        });
    });

    return dataSessionComponents;
};
export default getRowsSessionManual;
